import React, { useRef } from 'react';
import styled from 'styled-components';
import { Outline, Primary, Text } from '../styles/helper';
import variables from '../styles/variables.module.scss';

const buttonStyles = () => `
    transition : all ${variables.duration};
    height: 40px;
    -webkit-tap-highlight-color: transparent;
`;
const primaryFilledStyles = (theme) => `
    background-color : ${theme.primaryBgColor};
    border : 1px solid ${theme.primaryBgColor};
    color : ${theme.primaryTextColor};
    &:hover, &:focus{
    background-color : ${theme.primaryBgColorHover};
    border : 1px solid ${theme.primaryBgColorHover};
`;
const primaryOutlineStyles = (theme) => `
    background-color : transparent;
    border : 1px solid ${theme.primaryBgColor};
    color : ${theme.primaryBgColor};
    &:hover, &:focus{
    color : ${theme.primaryTextColorHover};
    background-color : ${theme.primaryBgColorHover};
    border : 1px solid ${theme.primaryBgColorHover};
`;
const primaryTextStyles = (theme) => `
    background-color : transparent;
    border : 0;
    color : ${theme.primaryBgColor};
    height: auto!important;
    padding: 0;
    text-align: left;
    font-weight: 600;
    line-height: ${variables.size_mdl};
    text-underline-offset: 3px;
    & .btn-desc{
      font-size: ${variables.size_sm};
    }
    &:hover, &:focus{
      color : ${theme.primaryBgColor};
    }
`;

const PrimaryButton = (theme) => `
  ${buttonStyles()}  
  ${primaryFilledStyles(theme)}
 
}`;

const outlineButton = (theme) => `
  ${buttonStyles()} 
  ${primaryOutlineStyles(theme)}
`;

const textButton = (theme) => `
  ${buttonStyles()} 
  ${primaryTextStyles(theme)}
`;

const ButtonContainer = styled.button.attrs(({ btnTheme }) => {
  return {
    className: `btn ${btnTheme === Text ? 'text' : '' } ${btnTheme === Primary ? 'filled' : '' }  ${btnTheme === Outline ? 'outline' : '' }`,
  };
})`
  ${({ theme, btnTheme }) =>
    (btnTheme === Primary && PrimaryButton(theme)) ||
    (btnTheme === Outline && outlineButton(theme)) ||
    (btnTheme === Text && textButton(theme))}
`;

export const Button =React.forwardRef((props:any, ref) => {
  let { children, description, theme = Primary, ...rest } = props;
  const localRef = useRef(null);
  rest.ref= ref || localRef;
 
// export function Button({ children, theme = Primary, ...rest }) {
  return (
    <>
     {/* {...(theme === Text ? { value: description } : '')} */}
      <ButtonContainer btnTheme={theme} {...rest}>
        {children}
        {/* {theme === Primary && <span className="d-block fw-r btn-desc">{description}</span>} */}
      </ButtonContainer>
    </>
  );
})